import React from 'react';
import { Image } from 'lucide-react';

export default function ImageUploadButton({
  label = 'Upload image',
  onSelect,
  accept = 'image/*',
  multiple = false,
  disabled = false,
  variant = 'chip',
  className = '',
  showLabel = false,
  tooltip
}) {
  const classes = [
    'image-upload',
    variant === 'chip' ? 'image-upload-chip' : 'image-upload-button',
    disabled ? 'disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <label
      className={classes}
      data-tooltip={tooltip || label}
      aria-label={label}
    >
      <Image className="w-4 h-4" />
      {(showLabel || variant !== 'chip') && <span>{label}</span>}
      <input
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={(event) => {
          const files = Array.from(event.target.files || []);
          if (onSelect) {
            if (multiple) {
              onSelect(files);
            } else if (files[0]) {
              onSelect(files[0]);
            }
          }
          event.target.value = '';
        }}
      />
    </label>
  );
}
